import { render, staticRenderFns } from "./cohorts-forum.vue?vue&type=template&id=33e01ee4&scoped=true"
import script from "./cohorts-forum.vue?vue&type=script&lang=js"
export * from "./cohorts-forum.vue?vue&type=script&lang=js"
import style0 from "./cohorts-forum.vue?vue&type=style&index=0&id=33e01ee4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e01ee4",
  null
  
)

export default component.exports